import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../gql/api';
import _ from 'lodash';

export const getPlacesByWorkspaceId = createAsyncThunk(
  'places/getDevicesByWorkspace',
  async (payload) => {
    const { workspaceId } = payload;
    const places = await api.places.getPlacesByWorkspace({
      workspaceId,
    });
    return places.data.getPlacesByWorkspace.places;
  }
);

export const deletePlaceById = createAsyncThunk(
  'places/deletePlaceById',
  async (placeId) => {
    const response = await api.places.deletePlaceById({
      placeId,
    });

    return response.data.deletePlaceById;
  }
);
